export * from './getValueLength';
export * from './array';
export var isFunction = function (value) {
    return typeof value === 'function';
};
export function isObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}
export var isPromise = function (value) {
    return value && typeof value.then === 'function';
};
export function isArray(value) {
    return Object.prototype.toString.call(value) === '[object Array]';
}
export function isString(value) {
    return Object.prototype.toString.call(value) === '[object String]';
}
export function isNumber(value) {
    return Object.prototype.toString.call(value) === '[object Number]';
}
export function isDate(value) {
    var _a;
    return Object.prototype.toString.call(value) === '[object Date]' && !isNaN((_a = value === null || value === void 0 ? void 0 : value.getTime) === null || _a === void 0 ? void 0 : _a.call(value));
}
export function isEmpty(value) {
    if (value === '') {
        return true;
    }
    if (value === undefined) {
        return true;
    }
    if (isObject(value)) {
        return Object.keys(value).length === 0;
    }
    if (isArray(value)) {
        return value.length === 0;
    }
    return false;
}
export function prefixZero(value) {
    var num = parseInt(value);
    if (num === NaN)
        return '';
    if (num >= 10)
        return num.toString();
    return "0".concat(num);
}
